import React from 'react'
import ManageSubscription from 'src/app/ManageSubscription/ManageSubscription'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { manageSubscriptionRouteProps } from 'src/navigation/routeProps'

const ManageSubscriptionAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsManageSubscription,
  routeProps: manageSubscriptionRouteProps,
  component: <ManageSubscription />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ManageSubscriptionAppRoute
